import { Fragment } from 'react';
import { View } from 'react-native';
import { useSelector } from 'react-redux';
import { Divider } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';

import { selectReservationCheckoutData } from '../../../RTK/utility/selectors';
import themeStyle from '../../../Theme/styles';

import QuantitySelectorSmall from '../../QuantitySelector/Small';
import ResponsiveText from '../../ResponsiveText';

import { DietaryCounterProps } from './types';

const DietaryCounter = ({ value, onChange }: DietaryCounterProps) => {
  const partySize = useSelector(
    (state) => selectReservationCheckoutData(state).size,
  );
  if (lodashIsEmpty(value)) return null;
  return value.map((val, i) => (
    <Fragment key={val.label}>
      <View
        style={[
          themeStyle.flexDirectionRowCenter,
          themeStyle.pageVerticalSpacingSmall,
        ]}
      >
        <ResponsiveText category="label" style={themeStyle.flex1}>
          {val.label}
        </ResponsiveText>
        <QuantitySelectorSmall
          disableIncrement={val.count === partySize}
          status="info"
          value={val.count}
          onQtyChange={(r) => onChange({ label: val.label, count: r })}
          onRemove={() => onChange({ label: val.label, count: 0 })}
        />
      </View>
      {i !== value.length - 1 && <Divider style={themeStyle.divider} />}
    </Fragment>
  ));
};

export default DietaryCounter;
